import { IMenu, IRoute, RenderRoutes } from "@src/routes";
import { NavBar } from "@funcional/react-ui";
import { SsoRolesEnum } from "@funcional/react-auth-ui";
import { Redirect } from "react-router-dom";
import queryFixedDiscountRulesRoutes from "./query-fixed-discount-rules/routes";
import registerFixedDiscountRulesRoutes from "./register-fixed-discount-rules/routes";
import viewFixedDiscountRulesRoutes from "./view-fixed-discount-rules/routes";
import editFixedDiscountRulesRoutes from "./edit-fixed-discount-rules/routes";
import configurationRefundTypeRoutes from "./configuration-refund-type/routes";
import transactionsRoutes from "./transactions/routes";
import financialReimbursementRoutes from "./financial-reimbursement/routes";

const menus: IMenu[] = [
  {
    label: "Reposição",
    path: "/refund",
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
      SsoRolesEnum.INDUSTRY,
    ],
    routes: [
      {
        label: "Regras de Desconto Fixo",
        path: "/refund/fixed-discount-rule",
        roles: [
          SsoRolesEnum.MASTER,
          SsoRolesEnum.SUPPORT,
          SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
          SsoRolesEnum.INDUSTRY,
        ],
      },
      {
        label: "Configuração do Tipo de Reposição",
        path: "/refund/refund-programs",
        roles: [
          SsoRolesEnum.MASTER,
          SsoRolesEnum.SUPPORT,
          SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
          SsoRolesEnum.INDUSTRY,
        ],
      },
      {
        label: "Transações",
        path: "/refund/transactions/programs",
        roles: [
          SsoRolesEnum.MASTER,
          SsoRolesEnum.SUPPORT,
          SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
          SsoRolesEnum.INDUSTRY,
        ],
      },
      {
        label: "Configuração Ressarcimento Financeiro",
        path: "/refund/financial-reimbursement",
        roles: [
          SsoRolesEnum.MASTER,
          SsoRolesEnum.SUPPORT,
          SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
          SsoRolesEnum.INDUSTRY,
        ],
      },
    ],
  },
];

const routes: IRoute[] = [
  {
    menu: { label: "Regras de Desconto Fixo" },
    path: "/refund",
    key: "REFUND",
    component: (props: any) => (
      <div className="flex w-full">
        <NavBar menus={menus} />
        <div className="p-8 overflow-x-hidden overflow-y-auto md:flex-1">
          <RenderRoutes {...props} />
        </div>
      </div>
    ),
    routes: [
      {
        path: "/refund/",
        key: "REFUND_ROOT",
        exact: true,
        component: () => <Redirect to="/refund/fixed-discount-rule" />,
      },
      ...registerFixedDiscountRulesRoutes,
      ...queryFixedDiscountRulesRoutes,
      ...viewFixedDiscountRulesRoutes,
      ...editFixedDiscountRulesRoutes,
      ...configurationRefundTypeRoutes,
      ...transactionsRoutes,
      ...financialReimbursementRoutes,
    ],
  },
];

export default routes;
